/**
 * update_proposal block. Confirm and Cancel render only on the live card.
 * Markup follows the web assistant UpdateProposalCard.
 */

import { t } from '../../../../i18n.js';

function actionButton(label, { disabled = false, primary = false, onClick }) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = primary ? 'ai-proposal__primary' : 'ai-proposal__ghost';
  button.textContent = label;
  button.disabled = disabled;
  if (!disabled && onClick) button.addEventListener('click', onClick);
  return button;
}

/**
 * @param {Object} block
 * @param {Object} [options]
 * @param {string} [options.messageId]
 * @param {Object} [options.listSelection]
 * @returns {HTMLElement}
 */
export function createUpdateProposal(block, options = {}) {
  const selection = options.listSelection || {};
  const live = selection.liveProposal;
  const isLive =
    !!live &&
    live.messageId === options.messageId &&
    live.block?.proposalId != null &&
    live.block.proposalId === block?.proposalId;
  const streaming = !!selection.streaming;

  const card = document.createElement('div');
  card.className = `ai-proposal${isLive ? '' : ' ai-proposal--dead'}${block?.drift ? ' ai-proposal--drift' : ''}`;

  const head = document.createElement('div');
  head.className = 'ai-proposal__head';

  const title = document.createElement('span');
  title.textContent = t('ai_review_changes');

  const target = document.createElement('span');
  const index = block?.index == null ? '' : `#${block.index}`;
  const label = block?.label || '';
  target.textContent = [index, label].filter(Boolean).join(' ');

  head.append(title, target);
  card.appendChild(head);

  const body = document.createElement('div');
  body.className = 'ai-proposal__body';

  if (block?.drift) {
    const drift = document.createElement('p');
    drift.className = 'ai-proposal__drift';
    drift.textContent = t('ai_changed_since');
    body.appendChild(drift);
  }

  const changes = Array.isArray(block?.changes) ? block.changes : [];
  if (changes.length) {
    const list = document.createElement('dl');
    list.className = 'ai-proposal__diff';
    changes.forEach((change) => {
      const field = document.createElement('dt');
      field.textContent = change?.fieldLabel || change?.field || '';

      const value = document.createElement('dd');
      if (change?.from) {
        const from = document.createElement('span');
        from.className = 'ai-proposal__from';
        from.textContent = String(change.from);
        value.appendChild(from);
      }
      const to = document.createElement('span');
      to.className = 'ai-proposal__to';
      to.textContent = change?.to == null ? '' : String(change.to);
      value.appendChild(to);
      list.append(field, value);
    });
    body.appendChild(list);
  }

  if (block?.comment) {
    const comment = document.createElement('p');
    comment.className = 'ai-proposal__comment';
    comment.textContent = block.comment;
    body.appendChild(comment);
  }

  if (isLive) {
    const foot = document.createElement('div');
    foot.className = 'ai-proposal__foot';
    foot.append(
      actionButton(t('ai_cancel'), {
        disabled: streaming,
        onClick: () => selection.onCancel?.(block),
      }),
      actionButton(t('ai_confirm'), {
        primary: true,
        disabled: streaming,
        onClick: () => selection.onConfirm?.(block),
      })
    );
    body.appendChild(foot);
  }

  card.appendChild(body);
  return card;
}
